import { render, staticRenderFns } from "./VisualizarUsuarioDialog.vue?vue&type=template&id=0279d27b&scoped=true"
import script from "./VisualizarUsuarioDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarUsuarioDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarUsuarioDialog.vue?vue&type=style&index=0&id=0279d27b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279d27b",
  null
  
)

export default component.exports